// src/components/MapLegend.jsx
import { Box, HStack, Text, VStack } from "@chakra-ui/react";

export default function MapLegend() {
  const Item = ({ color, label }) => (
    <HStack spacing={2}>
      <Box
        w="14px"
        h="14px"
        borderRadius="3px"
        bg={color}
        border="1px solid rgba(0,0,0,0.15)"
      />
      <Text fontSize="xs" color="gray.700">
        {label}
      </Text>
    </HStack>
  );

  return (
    <Box
      position="absolute"
      left="16px"
      bottom="80px"
      bg="white"
      borderRadius="md"
      shadow="md"
      p={3}
      zIndex={30}
      border="1px solid rgba(0,0,0,0.08)"
    >
      <VStack align="flex-start" spacing={2}>
        <Text
          fontSize="xs"
          fontWeight="bold"
          color="gray.800"
          textTransform="uppercase"
          letterSpacing="0.5px"
        >
          Map Legend
        </Text>

        <Item color="rgba(255,0,0,0.55)" label="Selected sector" />
        <Item color="rgba(255,0,0,0.35)" label="Hover" />
        <Item color="rgba(255,0,0,0.15)" label="Other sectors" />
      </VStack>
    </Box>
  );
}
